import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Offcanvas, Button } from 'react-bootstrap';
import { AiOutlineRight, AiOutlineDown } from 'react-icons/ai'; // Import icons
import Logo from './Logo';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const MobileMenu = ({ menuItems, onLoginClick, onSpeakClick }) => {
  const [show, setShow] = useState(false);
  const [openSubmenus, setOpenSubmenus] = useState({}); // State to track open submenus
  const location = useLocation(); // To detect route changes

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const toggleSubmenu = (index) => {
    setOpenSubmenus((prevState) => ({
      ...prevState,
      [index]: !prevState[index], // Toggle the submenu state
    }));
  };

  // Close all submenus on route change
  useEffect(() => {
    setOpenSubmenus({}); // Reset the submenu state to close all submenus when the route changes
  }, [location]);

  // Prevent closing the offcanvas when clicking on Login or Speak to an Expert
  const handleButtonClick = (e, callback) => {
    e.stopPropagation(); // Prevent click event from propagating and closing the canvas
    callback(); // Call the action (either onLoginClick or onSpeakClick)
  };

  return (
    <>
      {/* Toggle Button */}
      <Button className="menu-toggle" onClick={handleShow}>
        ☰
      </Button>

      {/* Offcanvas Menu */}
      <Offcanvas show={show} onHide={handleClose} placement="start">
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>
            <Logo />
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body className="d-flex flex-column justify-content-between">
          <ul className="list-unstyled">
            {menuItems.map((item, index) => (
              <li key={index} className="menuli mb-3">
                <div className="d-flex justify-content-between align-items-center">
                  <Link
                    to={item.path}
                    onClick={() => {
                      // Close the offcanvas when a link is clicked, unless it has a submenu
                      if (!item.subMenu) handleClose();
                    }}
                    className="text-decoration-none"
                  >
                    {item.label}
                  </Link>
                  {item.subMenu && (
                    <button
                      className="btn btn-sm btn-link p-0"
                      onClick={() => toggleSubmenu(index)}
                      aria-expanded={!!openSubmenus[index]}
                    >
                      {openSubmenus[index] ? (
                        <AiOutlineDown size={19} className="icon-down" />
                      ) : (
                        <AiOutlineRight size={19} className="icon-right" />
                      )}
                    </button>
                  )}
                </div>

                {/* Submenu */}
                {item.subMenu && openSubmenus[index] && (
                  <ul className="list-unstyled ps-3 mt-2">
                    {item.subMenu.map((subItem, subIndex) => (
                      <li key={subIndex} className="mb-4 mt-4">
                        <Link
                          to={subItem.path}
                          onClick={handleClose}
                          className="text-decoration-none"
                        >
                          {subItem.icon && (
                            <FontAwesomeIcon icon={subItem.icon} className="submenu-item-icon" />
                          )}
                          {subItem.label}
                        </Link>
                      </li>
                    ))}
                  </ul>
                )}
              </li>
            ))}
          </ul>

          {/* Login/Register Section */}
          <div className="login-section">
            <div className="d-grid gap-2 mb-3">
              <Button
                variant="link"
                onClick={(e) => handleButtonClick(e, onLoginClick)} // Call handleButtonClick with onLoginClick
                className="text-decoration-none text-start"
                style={{ color: '#333', fontSize: '1rem' }}
              >
                Log in / Register
              </Button>
            </div>
            <div className="d-grid gap-2">
              <Button
                variant="link"
                onClick={(e) => handleButtonClick(e, onSpeakClick)} // Call handleButtonClick with onSpeakClick
                className="text-decoration-none text-start"
                style={{ color: '#333', fontSize: '1rem' }}
              >
                Speak to an Expert
              </Button>
            </div>
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

export default MobileMenu;
